import { apiPostModel, postApi } from '../../../useApiHook';

export const createClinicianMileageCap = (auth, entityModel, callback) => {
  const postModel = apiPostModel('CreateClinicianMileageCap', entityModel, callback);
  postApi(auth, postModel);
};

export const createOrUpdateClinicianStartingPostcode = (auth, entityModel, callback) => {
  const postModel = apiPostModel('CreateOrUpdateClinicianStartingPostcode', entityModel, callback);
  postApi(auth, postModel);
};

export const createOrEditNonPatientActivityType = (auth, entityModel, callback) => {
  const enpointName = entityModel.Id > 0 ? 'EditNonPatientActivityType' : 'CreateNonPatientActivityType';
  const postModel = apiPostModel(enpointName, entityModel, callback);
  postApi(auth, postModel);
};

export const createOrEditActivityType = (auth, entityModel, callback) => {
  const enpointName = entityModel.id > 0 ? 'EditActivityType' : 'CreateActivityType';
  const postModel = apiPostModel(enpointName, entityModel, callback);
  postApi(auth, postModel);
};

export const updateReasonStatus = (auth, model, callback) => {
  const postModel = apiPostModel('UpdateReasonStatus', model, callback);
  postApi(auth, postModel);
};

export const createReason = (auth, model, callback) => {
  const postModel = apiPostModel('CreateReason', model, callback);
  postApi(auth, postModel);
};

export const createOrEditActivity = (auth, model, callback, errorCallback) => {
  const enpointName = model.ActivityId > 0 ? 'UpdateActivity' : 'CreateActivity';
  const postModel = apiPostModel(enpointName, model, callback, errorCallback);
  postApi(auth, postModel);
};

export const updateActivityActiveStatus = (auth, model, callback, errorCallback) => {
  const enpointName = model.IsActive ? 'DeactivateActivity' : 'ActivateActivity';
  const postModel = apiPostModel(enpointName, { ActivityId: model.ActivityId }, callback, errorCallback);
  postApi(auth, postModel);
};

export const createCancellingParty = (auth, model, callback) => {
  const postModel = apiPostModel('CreateCancellingParty', model, callback);
  postApi(auth, postModel);
};

export const updateCancellingPartyStatus = (auth, model, callback) => {
  const postModel = apiPostModel('UpdateCancellingPartyStatus', model, callback);
  postApi(auth, postModel);
};

export const editProviderTeamMapping = (auth, model, callback) => {
  const postModel = apiPostModel('UpdateProviderTeamMapping', model, callback);
  postApi(auth, postModel);
};

export const sendRequestToExternalProvider = (auth, model, callback) => {
  const postModel = apiPostModel('SendAppointment', model, callback);
  postApi(auth, postModel);
};

export const discardRequestToExternalProvider = (auth, model, callback) => {
  const postModel = apiPostModel('DiscardExternalProviderRequest', model, callback);
  postApi(auth, postModel);
};

export const editClinicianUsernameMapping = (auth, model, callback, errorCallback) => {
  const postModel = apiPostModel('UpdateClinicianUsernameMapping', model, callback, errorCallback);
  postApi(auth, postModel);
};

export const updateConfigureAssistedPlanner = (auth, model, callback, errorCallback) => {
  const postModel = apiPostModel('UpdateConfigureAssistedPlanner', model, callback, errorCallback);
  postApi(auth, postModel);
};

export const createOutcomeCode = (auth, model, callback, errorCallback) => {
  const postModel = apiPostModel('CreateOutcomeCode', model, callback, errorCallback);
  postApi(auth, postModel);
};

export const updateOutcomeCodeStatus = (auth, model, callback) => {
  const postModel = apiPostModel('UpdateOutcomeCodeStatus', model, callback);
  postApi(auth, postModel);
};
